import React from 'react'

const About = () => {
  return (
    <div className='account-wrapper'></div>
  )
}

export default About